import {Component, Injector} from "@angular/core";
import {ProductLineSearchModel} from "../product-line-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {ProductLineSearchPageComponent} from "../product-line-search-page/product-line-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-product-line-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(ProductLineSearchModel),
        registerSearchControl(ProductLineMultiSelectSearchControlComponent)
    ]
})
export class ProductLineMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<ProductLineSearchModel> {
    constructor(model: ProductLineSearchModel, injector: Injector) {
        super(model, injector, "sellableId", "name");

        this.extendedSearchComponent = ProductLineSearchPageComponent;
    }
}
